// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-comments-dialog--desktop .v-dialog__content{display:block;height:auto;width:auto}.w-comments-dialog--desktop .v-dialog__content .v-dialog{position:fixed;margin:0;bottom:80px;right:16px}", ""]);
// Exports
module.exports = exports;
